function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAarFile = function SvgAarFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87B857",
    d: "M4 2h11l5 5v15H4",
    style: {
      fill: "#87B857"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M17.8 17.42c.03.06.05.12.05.18l.1 1.22c0 .04-.02.08-.06.1-.1.03-.1.03-.2 0l-1.03-.7c-.05-.02-.1-.07-.13-.13l-2.06-3.5c-.76.4-1.64.6-2.57.6-.92 0-1.8-.26-2.56-.68l-2.04 3.5c-.04.06-.08.1-.14.14l-1 .7c-.06 0-.1.02-.15 0-.03-.03-.06-.07-.05-.1l.1-1.24c0-.06 0-.12.04-.18l4.17-7.1 1 1-1.22 2.1c.54.3 1.2.5 1.9.5s1.3-.2 1.9-.5l-1.27-2.1 1-1 1.32 2.2c.6-.67.95-1.55.95-2.54h1.4c0 1.5-.63 2.84-1.6 3.8l2.1 3.63z",
    style: {
      fill: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M13 6h-2v1.5h-.5c-.28 0-.5.23-.5.5v2l1.65 1.65c.2.2.5.2.7 0L14 10V8c0-.27-.23-.5-.5-.5H13V6zm-1 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z",
    style: {
      fill: "#6F6F6F"
    }
  })));
};
export default SvgAarFile;